export const stageBannerSizes = {
  // sm should be 767px width, not 256px - talk with CRM about it
  sm: { width: 256, height: 125 },
  md: { width: 385, height: 238 },
  lg: { width: 475, height: 230 },
  xl: { width: 679, height: 333 },
};
